<template>
  <div class="editor">

    <div class="line">
      <span class="label" contenteditable="false">Razón social:</span>
      <span
        ref="razon"
        class="value"
        contenteditable="true"
        @input="actualizar"
        @keydown="keydown"
      ></span>
    </div>

    <div class="line">
      <span class="label" contenteditable="false">NIT/CI:</span>
      <span
        ref="nit"
        class="value"
        contenteditable="true"
        @input="actualizar"
        @keydown="keydown"
      ></span>
    </div>

    <div class="line">
      <span class="label" contenteditable="false">Observaciones:</span>
      <span
        ref="obs"
        class="value"
        contenteditable="true"
        @input="actualizar"
        @keydown="keydown"
      ></span>
    </div>

  </div>
</template>

<script>
export default {

  props:{
    value:{
      type:String,
      default:""
    }
  },

  mounted(){
    this.cargarTexto(this.value);
  },

  watch:{
    value(nuevo){
      if(nuevo !== this.obtenerTexto()){
        this.cargarTexto(nuevo);
      }
    }
  },

  methods:{

    actualizar(){
      this.$emit("input", this.obtenerTexto());
    },

    obtenerTexto(){

      return [
        "Razón social: " + this.$refs.razon.innerText.trim(),
        "NIT/CI: " + this.$refs.nit.innerText.trim(),
        "Observaciones: " + this.$refs.obs.innerText.trim()
      ].join("\n");

    },

    cargarTexto(texto){

      const razon = texto.match(/Razón social:\s*(.*)/i);
      const nit = texto.match(/NIT\/CI:\s*(.*)/i);

      const obs = texto.match(
        /Observaciones:\s*([\s\S]*)/i
      );

      this.$refs.razon.innerText = razon ? razon[1] : "";
      this.$refs.nit.innerText   = nit ? nit[1] : "";
      this.$refs.obs.innerText   = obs ? obs[1] : "";

    },

    keydown(e){

      if(e.key==="Backspace"){

        const sel = window.getSelection();

        if(sel.rangeCount){

          const range = sel.getRangeAt(0);

          if(range.startOffset===0 && range.collapsed){
            e.preventDefault();
          }

        }

      }

    }

  }

}
</script>

<style scoped>

.editor{
    width:100%;
    min-height:220px;
    border:1px solid #bbb;
    border-radius:6px;
    background:white;
    padding:12px;
    font-size:15px;
}

.line{
    display:flex;
    align-items:flex-start;
    margin-bottom:2px;
}

.label{
    flex-shrink:0;
    width:110px;
    font-weight:bold;
    color:#0055aa;
    user-select:none;
    padding-top:8px; 
}

.value{
    flex:1;
    min-height:18px;
    padding:0px 8px;
    outline:none;
    border-bottom:1px solid #bdbdbd;
    white-space:pre-wrap;
    word-break:break-word;
}

.value:focus{
    border-bottom:2px solid #1976d2;
}

.value:empty::before{
    content:"Escriba aquí...";
    color:#b5b5b5;
    pointer-events:none;
}

</style>